/**
 * @returns {Promise<any>}
 */
export const getLocation = () => {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((data) => {
                const {coords: {latitude, longitude}} = data
                resolve({lat: latitude, lng: longitude});
            }, reject);
        } else {
            reject(new Error('Geolocation is not supported by this browser.'));
        }
    });
}

/**
 * @returns {Promise<any>}
 */
export function getCoords() {
    return new Promise((resolve, reject) =>
        navigator.permissions ?
            navigator.permissions.query({
                name: 'geolocation'
            }).then(permission =>
                permission.state === "granted"
                    ? navigator.geolocation.getCurrentPosition(pos => resolve(pos.coords))
                    : resolve(null)
            ) :
            reject(new Error("Permission API is not supported"))
    )
}



// WEBPACK FOOTER //
// ./src/components/locator/helpers/geolocation.js